module.exports = __webpack_public_path__ + "64703b49abd07011ade52039a98ef985.png";